module.exports = __webpack_public_path__ + "static/img/print.2890fbb8.png";